import type { Service } from "@/types";
import { isSafeHttpOrHttpsUrl } from "@/lib/security/safe-href";

/** Auto-disable live preview after this many client-reported embed failures. */
export const LIVE_PREVIEW_EMBED_FAILURE_DISABLE_THRESHOLD = 2;

export function normalizeServiceDemoUrl(raw?: string | null): string | null {
	if (typeof raw !== "string" || !raw.trim()) return null;
	const t = raw.trim();
	const normalized = /^(https?:)?\/\//i.test(t) ? t : `https://${t}`;
	return isSafeHttpOrHttpsUrl(normalized) ? normalized : null;
}

export function isServiceLivePreviewAvailable(
	service: Pick<Service, "demoUrl" | "livePreviewDisabled">,
): boolean {
	if (service.livePreviewDisabled === true) return false;
	return normalizeServiceDemoUrl(service.demoUrl) != null;
}
